module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-message-fade"
    },
    on: {
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: [
      'el-message',
      'rt-message',
      _vm.type && !_vm.iconClass ? ("rt-message--" + _vm.type) : '',
      _vm.center ? 'is-center' : '',
      _vm.showClose ? 'is-closable' : '',
      _vm.customClass
    ],
    style: (_vm.positionStyle),
    attrs: {
      "role": "alert"
    },
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('icon', {
    staticClass: "rt-message-prefix-icon",
    class: ("rt-message-" + _vm.type),
    attrs: {
      "name": _vm.type === 'info' || _vm.type === 'success' ? 'rt-base-circle-check-filled' : 'rt-base-circle-warning-filled',
      "size": "16"
    }
  }), _vm._v(" "), _vm._t("default", function() {
    return [(!_vm.dangerouslyUseHTMLString) ? _c('p', {
      staticClass: "el-message__content"
    }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]) : (_vm.wrapMessage) ? _c('div', {
      staticClass: "el-message__content"
    }, _vm._l((_vm.wrapMessage), function(item, index) {
      return _c('div', {
        key: index
      }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
    }), 0) : _c('p', {
      staticClass: "el-message__content",
      domProps: {
        "innerHTML": _vm._s(_vm.message)
      }
    })]
  }), _vm._v(" "), (_vm.showClose) ? _c('rt-button', {
    staticClass: "rt-message-close",
    attrs: {
      "icon-name": "rt-base-close-x",
      "text": "",
      "icon-size": "16"
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16113e7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/message/src/main.vue
// module id = 2076
// module chunks = 137